import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../views/security/view.login';
import Register from '../views/security/view.register';

export default function SecurityRouting() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
